import React, { createContext, useContext } from 'react';
import type { ChangeTracker } from '../hooks/useChangeTracker';

const ChangeTrackerContext = createContext<ChangeTracker | null>(null);

export function useChangeTrackerContext(): ChangeTracker | null {
  return useContext(ChangeTrackerContext);
}

interface ChangeTrackerProviderProps {
  tracker: ChangeTracker;
  children: React.ReactNode;
}

export function ChangeTrackerProvider({ tracker, children }: ChangeTrackerProviderProps): React.ReactElement {
  return (
    <ChangeTrackerContext.Provider value={tracker}>
      {children}
    </ChangeTrackerContext.Provider>
  );
}
